// Shared by SignalsChartCard (chips), MLSignalCard, and both chart components so a channel's
// dot color and label stay consistent across the chips row, the stack, and the overlay.

// Semantic tokens only — resolves correctly in both themes (see src/index.css).
// Theme colors in src/index.css are oklch(...) values, i.e. already complete CSS colors —
// do NOT wrap them in hsl(...), that produces invalid CSS (hsl(oklch(...))) and SVG paints
// silently drop it.
const CHANNEL_PALETTE = [
  'var(--primary)',
  'var(--chart-1, var(--primary))',
  'var(--chart-2, var(--primary))',
  'var(--chart-3, var(--primary))',
  'var(--chart-4, var(--primary))',
];

export function channelColor(index: number): string {
  return CHANNEL_PALETTE[index % CHANNEL_PALETTE.length];
}

// Real tags served by signals_provider; anything else falls back to the raw tag.
const TAG_I18N_KEYS: Record<string, string> = {
  SPINDLE_PWR: 'spindlePwr',
  X_FOLLERR: 'xFollErr',
  Y_FOLLERR: 'yFollErr',
  Z_FOLLERR: 'zFollErr',
};

export function channelLabel(tag: string, t: (key: string) => string): string {
  const i18nKey = TAG_I18N_KEYS[tag];
  return i18nKey ? t(`signals.tags.${i18nKey}`) : tag;
}

// Chart X values are relative seconds from SignalsSeriesPayload.startTime (t=0), not
// absolute timestamps — kept that way for chart math (LTTB, shared domain across
// channels). This reconstructs real clock time for axis ticks/tooltips only:
// startTime + relativeSeconds. Shared by SignalChartStack and SignalChartOverlay so
// both format identically.
export function makeTimeTickFormatter(startTime: string): (relativeSeconds: number) => string {
  const startMs = new Date(startTime).getTime();
  return (relativeSeconds: number) => {
    if (!Number.isFinite(startMs) || !Number.isFinite(relativeSeconds)) {
      return String(relativeSeconds);
    }
    const date = new Date(startMs + relativeSeconds * 1000);
    if (Number.isNaN(date.getTime())) return String(relativeSeconds);
    return date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };
}
